<template>
  <div class="list-container">
    <div
      v-for="item in currentItems"
      :key="item.id"
      class="chip"
    >
      <div v-if="item">
        <span>{{ item.name }}</span>
        <img
          src="@/assets/UncheckWhite.svg"
          alt="remove-button"
          v-if="editable"
          class="remove-button"
          @click="onRemove(item)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileTags',
  props: {
    /**
     * Array of items to display. An item should have an id and a name.
     */
    items: {
      type: Array,
      required: true
    },
    editable: Boolean,
    onRemove: {
      type: Function,
      required: true
    }
  },
  computed: {
    currentItems () {
      return this.items.slice().sort((a, b) => a.name && a.name.localeCompare(b.name))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.list-container {
    display: flex;
    flex-wrap: wrap;
    padding: 0 0;
}

.chip {
    display: flex;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    line-height: 24px;
    background: $primary-color;
    padding: 2px 12px;
    border-radius: 5px;
    margin: 5px;

    .remove-button {
        cursor: pointer;
        margin: -7px;
        margin-left: 4px;
    }
}
</style>
